import moment from 'moment';
import getItemStyles from '../../../utils/item-styles';

let blankItemStyle = getItemStyles('no-info');

const blockFutureDays = (startDate, groups, items, scheduleFormat) => {
  const currentDate = moment();
  startDate = moment(startDate);
  for (let group of groups){
    // only apply logic in loop to everyday (starting at i = 0) if sched begins in future (after currentDate)
    let i = startDate.isAfter(currentDate) ? 0 : 1;
    for (i; i < scheduleFormat; i++) {
      const date = moment(startDate).add(i, 'days');
      // only applies to future days so ignore days after startDate that are still before currentDate,
      if (date.isAfter(currentDate)) {
        const blankItem = {
          id: `${group.id}-no-info-${date.format('M/D')}`,
          itemType: 'no-info',
          group: group.id,
          title: "No info",
          start_time: moment(date).startOf('day'),
          end_time: moment(date).endOf('day'),
          backgroundColor: blankItemStyle.backgroundColor,
          color: blankItemStyle.color,
          borderStyle: blankItemStyle.borderStyle,
          borderColor: blankItemStyle.borderColor
        };
        items.push(blankItem);
      }
    }
  }
  return items;
}

export default blockFutureDays;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/live-schedule-view-security-filter/blockFutureDays.js